import React from "react";
import { Badge } from "../../../ui/badge";

const VARIANTS = {
  active: "success",
  draft: "secondary",
  inactive: "outline",
  pending_signup: "warning",
  deactivated: "outline",
  departed: "destructive",
};

const LABELS = {
  active: "Active",
  draft: "Draft",
  inactive: "Inactive",
  pending_signup: "Pending",
  deactivated: "Deactivated",
  departed: "Departed",
};

/**
 * Renders a colored badge for a corporate or member status string.
 */
const StatusBadge = ({ status, className }) => {
  const variant = VARIANTS[status] || "outline";
  const label = LABELS[status] || status;
  return (
    <Badge variant={variant} className={className}>
      {label}
    </Badge>
  );
};

export default StatusBadge;
